angular.module('homebot.directives')
.directive('backLink', [function(){
  return {
    restrict: 'A',
    controllerAs: 'backLinkCtrl',
    bindToController: {
      fallbackUrl: '@',
    },
    scope: { },
    controller: function(){ },

    link: function($scope, el, attrs){
      el.bind('click', function(){
        let origin = `${window.location.protocol}//${window.location.host}/admin`;

        if(document.referrer.indexOf(origin) === 0) // assume back page is correct if they came from our domain
          window.history.back();
        else
          el[0].setAttribute('href', attrs.fallbackUrl);
      });
    }
  };
}]);
